import React, { useState, useEffect } from 'react';
import './WhatsAppButton.css';

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 4000);
    }, 3500);
    return () => { clearTimeout(timer); clearTimeout(tooltipTimer); };
  }, []);

  const phone = '33775215157';
  const message = encodeURIComponent('Bonjour Nexia Digital ! Je souhaite obtenir des informations sur vos services.');
  const url = `https://wa.me/${phone}?text=${message}`;

  if (!visible) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="wa-btn"
      aria-label="Contacter sur WhatsApp"
    >
      {showTooltip && (
        <div className="wa-tooltip">
          💬 Besoin d'aide ? Écrivez-nous !
        </div>
      )}
      <div className="wa-pulse" />
      <i className="fa-brands fa-whatsapp" />
    </a>
  );
}
